export default __webpack_public_path__ + "static/media/logo-us-American-girl.f793bd3d.svg";